import { getCookie } from "services/cookies";
import { COOKIES } from "./cookies";
import {
  isProductionDomain,
  isSandboxDomain,
  PRODUCTION_HOSTNAMES,
  SANDBOX_HOSTNAMES
} from "./domains";

export { isProductionDomain, isSandboxDomain, PRODUCTION_HOSTNAMES, SANDBOX_HOSTNAMES };

// Cookie is set by the server from APP_HOST/REACT_APP_APP_HOST so the same build works per environment
const rawAppHost =
  getCookie(COOKIES.APP_HOST) ||
  process.env.REACT_APP_APP_HOST ||
  process.env.APP_HOST;

function decodeAppHost(value) {
  if (typeof value !== "string" || !value.trim()) return "";
  const trimmed = value.trim();
  try {
    const decoded = decodeURIComponent(trimmed);
    return decoded;
  } catch {
    return trimmed;
  }
}

const decodedHost = decodeAppHost(rawAppHost);

/** Base URL: must be full URL with https:// (or http://). No auto-prefix. */
const APP_BASE_URL =
  decodedHost &&
  (decodedHost.startsWith("http://") || decodedHost.startsWith("https://"))
    ? decodedHost
    : "";

function getAppHostname() {
  if (!APP_BASE_URL) return "";
  try {
    return new URL(APP_BASE_URL).host || "";
  } catch {
    return "";
  }
}

const APP_HOSTNAME = getAppHostname();

const GRAPHQL_CMS_BASE_URL = `${APP_BASE_URL}/www-cms/graphql`;
const GRAPHQL_PORTAL_URL = `${APP_BASE_URL}/portal-api/graphql`;
const RAISE_BFF_URL = `${APP_BASE_URL}/support`;
const RAISE_QUERY_URL = `${APP_BASE_URL}/query`;
const RAISE_CHECKOUT_URL = `${APP_BASE_URL}/checkout`;
const RAISE_API_V1_URL = `${APP_BASE_URL}/api/v1`;

export {
  APP_BASE_URL,
  APP_HOSTNAME,
  GRAPHQL_CMS_BASE_URL,
  GRAPHQL_PORTAL_URL,
  RAISE_BFF_URL,
  RAISE_QUERY_URL,
  RAISE_CHECKOUT_URL,
  RAISE_API_V1_URL
};
